import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { SiteModeListComponent } from './site-mode-list.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  exports: [SiteModeListComponent],
  declarations: [SiteModeListComponent],
})
export class SiteModeListModule { }
